<template>
  <b-container fluid class="RwvBookTable">
    <h1> Bücher </h1>
    <div class="books">
      <!-- Table https://bootstrap-vue.org/docs/components/table -->
      <b-table
        :items="allBooks"
        :fields="fields"
        sort-by="slug"
        hover
        @row-clicked="onRowSelected"
      >
        <template #cell(slug)="data">
          {{data.value.split("-")[0]}}
        </template>
        <template #cell(slug)="data">
          {{data.value.split("-")[0]}}
        </template>
        <template #cell(title)="data">
          {{data.value.replace("Reparaturanleitung", "")}}
        </template>
        <template #cell(isbns)="data">
          <div v-if="data.value.length == 1" style="width: 160px">
            {{ data.value[0].isbn }}
          </div>
        </template>
      </b-table>

    </div>
    <!-- <div v-if="isLoadingBooks" class="article-preview">Bücher werden geladen...</div> -->
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_BOOKS,
  FETCH_BOOKS_COUNT
} from "@/store/actions.type";
export default {
  name: "RwvBookTable",
  data() {
    return {
      fields: [
          {
            key: 'slug',
            label: 'Band',
            sortable: true
          },
          {
            key: 'title',
            label: "Titel"
          },
          {
            key: 'isbns',
            label: "ISBN",

          }
        ]
      // TODO Link zum kaufen
      // TODO E-Book verfügbar: "✅ / ❌"
      // TODO Buch online lesebar: "✅ / ❌"
    };
  },
  components: {
    //
  },
  computed: {
    filterdBooks() {
      var me = this;
      return me.books.filter(book => {
        if (book.slug.split("-")[1] == "1") {
          return book
        }
      })
    },
    // NO IDEA what listConfig does
    // listConfig() {
    //   const params = {
    //     include: [
    //       {
    //         relation: "variants",
    //         scope: {
    //           include: {
    //             relation: "model"
    //           }
    //         }
    //       }
    //     ],
    //     fields: {
    //       urls: false,
    //       isLightTheme: false,
    //       createdAt: false,
    //       updatedAt: false,
    //       image: false
    //     }
    //   }
    //   const offset = (this.currentPage - 1) * this.itemsPerPage;
    //   return params
    // },
    allBooks() {
      var books = JSON.parse(JSON.stringify(this.filterdBooks))
      return books
    },
    ...mapGetters(["booksCount", "isLoadingBooks", "books", "defaultParamsBooks"])
  },
  mounted() {
    this.$store.dispatch(FETCH_BOOKS_COUNT);
    this.fetchBooks();
  },
  methods: {
    fetchBooks() {
      console.log(this.defaultParamsBooks)
      this.$store.dispatch(FETCH_BOOKS, JSON.parse(JSON.stringify(this.defaultParamsBooks)));
    },
    onRowSelected(book) {
      console.log(book);
      this.$router.push({name: 'book', params: { slug: book.slug }})
    },
  }
};
</script>

<style lang="scss">
// $five-images-width: 975px;
$four-images-width: 780px;
$three-images-width: 585px;
$two-images-width: 390px;
$one-images-width: 195px;
.books {
  margin: auto;
  max-width: $one-images-width;
  overflow: hidden;
  .RwvBookTile {
    width: 100%;
    height: 275px;
  }
  @media screen and (min-width: $two-images-width) {
    max-width: $two-images-width;
    .RwvBookTile {
      width: 50%;
      &.adTile {
        width: 100%;
      }
    }
  }
  @media screen and (min-width: $three-images-width) {
    max-width: $three-images-width;
    .RwvBookTile {
      width: 33.3%;
      &.adTile {
        width: 66.6%;
      }
    }
  }
  @media screen and (min-width: $four-images-width) {
    max-width: $four-images-width;
    .RwvBookTile {
      width: 25%;
      &.adTile {
        width: 50%;
      }
      opacity: 0.65;
      &:hover, &:active, &:focus {
        opacity: 1;
      }
    }
  }
}
</style>
